import React, { useRef } from 'react';
import { Box, Container, css } from '@mui/material';
import { Global } from '@emotion/react';
import { PanelsContainer } from './components/panels-container/panels-container';
import { Header } from './components/ui/header';
import { Steps, StepsHandle } from './components/steps/steps';
import { Footer } from './components/ui/footer';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const cssGlobals = {
  toastWidth: '400px',
  boxHeight: '600px',
  containerWidth: '1000px',
  panelsContainerMaxWidth: '1400px',
}

const globalStyles = css`
  * {
    box-sizing: border-box;
  }

  .Toastify {
    &__toast-body {
      padding: 15px 10px;
      line-height: 1.5;
      font-size: 14px;
    }

    &__toast-icon {
      margin-inline-end: 15px;
    }
  }
`

function App() {
  const steps = useRef<StepsHandle>(null);
  const setStepHandle = (step: number) => {
    if (steps.current) {
      steps.current.setActiveStep(step)
    }
  }

  return (<>
      <Global styles={globalStyles} />
      <Container
          maxWidth={false}
          sx={{
            display: 'flex',
            maxWidth: cssGlobals.panelsContainerMaxWidth,
            flexDirection: 'column',
            gap: 4,
            my: 6,
            mb: 5
          }}
      >
        <Header />
        <Steps ref={steps} />
        <Box sx={{ mt: 2 }}>
          <span>Here are some JSON-LD samples to test: </span>
          <a href={process.env.PUBLIC_URL + '/sample/sample1.jsonld'} download><b>Sample 1</b></a>, <a href={process.env.PUBLIC_URL + '/sample/sample2.jsonld'} download><b>Sample 2</b></a>, <a href={process.env.PUBLIC_URL + '/sample/sample3.jsonld'} download><b>Sample 3</b></a>
        </Box>
        <PanelsContainer setStepHandle={setStepHandle} />
      </Container>
      <ToastContainer
        style={{ width: cssGlobals.toastWidth }}
        transition={Zoom}
        position="top-center"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
      />
      <Footer />
    </>
  );
}

export default App;

